import * as _ from 'lodash';

export const CHANNEL_SETUP_RULES = {
  sequence: 'CHANNEL_MANAGE_CHANNEL_CONFIGURATION',
  backup: 'CHANNEL_MANAGE_CHANNEL_CONFIGURATION',
  filters: 'CHANNEL_MANAGE_FILTER_AND_TIMING',
  blacklist: 'CHANNEL_MANAGE_BLACKLIST',
  unsubscribe: 'CHANNEL_MANAGE_UNSUBSCRIBE',
  templates: 'CHANNEL_MANAGE_TAG_BASED_TEMPLATE',
} as const;

export type ChannelSetupTab = keyof typeof CHANNEL_SETUP_RULES;

export const CHANNEL_SETUP_TABS: ChannelSetupTab[] = ['sequence', 'backup', 'filters', 'blacklist', 'unsubscribe', 'templates'];

export function channelSetupAdminRules(): Record<string, { read?: boolean; write?: boolean }> {
  const source = Helpers?.adminRulesDic || {};
  const picked: Record<string, { read?: boolean; write?: boolean }> = {};
  Object.values(CHANNEL_SETUP_RULES).forEach((key) => {
    const rule = source[key];
    if (rule) {
      picked[key] = { read: Boolean(rule.read), write: Boolean(rule.write) };
    }
  });
  return picked;
}

export function isChannelSetupFullAdmin(authDetails: any): boolean {
  const accessLevel = _.get(authDetails, 'manager.access_rules.admin.access_level')
    ?? _.get(authDetails, 'manager.access_level');
  return accessLevel == 1;
}

export function hasChannelSetupRule(
  adminRulesDic: Record<string, any>,
  ruleKey: string,
  mode: 'read' | 'write',
): boolean {
  const rule = adminRulesDic?.[ruleKey];
  if (!rule || _.isEmpty(rule)) {
    return false;
  }
  if (mode === 'write') {
    return Boolean(rule.write);
  }
  return Boolean(rule.read || rule.write);
}

export function canSeeChannelSetupTab(
  tab: ChannelSetupTab,
  adminRulesDic: Record<string, any>,
  isFullAdmin: boolean,
): boolean {
  if (isFullAdmin) {
    return true;
  }
  return hasChannelSetupRule(adminRulesDic, CHANNEL_SETUP_RULES[tab], 'read');
}

export function canWriteChannelSetupTab(
  tab: ChannelSetupTab,
  adminRulesDic: Record<string, any>,
): boolean {
  return hasChannelSetupRule(adminRulesDic, CHANNEL_SETUP_RULES[tab], 'write');
}

export function canSeeChannelSettingsMenu(adminRulesDic: Record<string, any>): boolean {
  if (!adminRulesDic || _.isEmpty(adminRulesDic)) {
    return false;
  }
  return CHANNEL_SETUP_TABS.some((tab) => hasChannelSetupRule(adminRulesDic, CHANNEL_SETUP_RULES[tab], 'read'));
}
